import { render } from "./analysis3.vue?vue&type=template&id=23889dc8&scoped=true"
import script from "./analysis3.vue?vue&type=script&lang=js"
export * from "./analysis3.vue?vue&type=script&lang=js"

import "./analysis3.vue?vue&type=style&index=0&id=23889dc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23889dc8"]])

export default __exports__